import React from 'react'
import styled from 'styled-components'
import { string, oneOf } from 'prop-types'

const StoryHeadlineStyle = styled.h1`
  padding: 10px;

  &.headline {
    background: #008a34;
    color: white;
  }

  &.warning {
    background: red;
    padding-bottom: 10px;
    color: white;
  }
`

const StoryHeadline = ({ headline, type, ...rest }) => {
  const headLineClass = type === 'headline' ? 'headline' : 'warning'

  return (
    <StoryHeadlineStyle className={ headLineClass } { ...rest }>
      {headline}
      {headline}
      {headline}
      {headline}
    </StoryHeadlineStyle>
  )
}

StoryHeadline.defaultProps = {
  type: 'headline',
}

StoryHeadline.propTypes = {
  headline: string.isRequired,
  type: oneOf(['headline', 'warning']),
}

export default StoryHeadline
